import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { UserContext } from '../../context';
import _ from 'lodash';
import { CBSupportEnv } from '../../common/constants';

const PrivateRoute = (props) => {
  const { userInfo, activeBU } = useContext(UserContext);
  const [checkNow, setCheckNow] = useState(false);
  const companyId = Number(localStorage.getItem('__current_company_id'));
  useEffect(() => {
    if (activeBU.perms) {
      setCheckNow(true);
    }
  }, [activeBU.perms]);
  const hasAccess = _.find(
    activeBU.perms,
    (perm) => perm.screen_name === props.access,
  );

  if (!checkNow) return null;
  if (
    (props.access === 'CB-Support' ||
      props.access === 'CB-UnAssigned' ||
      props.access === 'CB-AssignedToMe') &&
    companyId != CBSupportEnv
  ) {
    return <Navigate to="/forbidden" />;
  }
  return userInfo.isAdmin || hasAccess || props.path === 'Notification' ? (
    props.component
  ) : (
    <Navigate to="/forbidden" />
  );
};

export default PrivateRoute;
